export const CLIP_JSP = 'Clip.jsp';
export const CLIP_LOAN_JSP = 'clipReportSBMA30_edoc.jsp';
export const CLIP_BANCA_JSP = 'clipReportBR.jsp';
export const CLIP_FUND_JSP = 'clipReportFund.jsp';

// #전자문서 중계서버
// EDOC_RELAY_SERVER_URL_1=http://10.61.17.198:8580
// EDOC_RELAY_SERVER_URL_2=http://10.61.17.198:8680
// EDOC_RELAY_SERVER_URL_ACTION=/EdocCommonBizService.act
//     #EDOC 1서버 SCP 전송여부 확인
// EDOC_CHECK_SCP_PATH1 = http://10.61.17.198:8580/EdocCommonBizService.act
// #EDOC 2서버 SCP 전송여부 확인
// EDOC_CHECK_SCP_PATH2 = http://10.61.17.198:8580/EdocCommonBizService.act
// const LOAN_CLIP_REPORT_URL = 'https://clipsit.standardchartered.co.kr/clip/';

// const CLIP_REPORT_URL = 'https://clipsit.standardchartered.co.kr/clip/';
export const CLIP_REPORT_URL = '/local/clip/'; // // local cors 우회(proxy)
